export default __webpack_public_path__ + "static/media/first.b57c4bc6.svg";